module.exports = __webpack_public_path__ + "img/1523036469.7c780d5a.jpg";